import script from "./PromotionsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionsGrid.vue?vue&type=script&setup=true&lang=js"

import "./PromotionsGrid.vue?vue&type=style&index=0&id=e39f9660&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e39f9660"]])

export default __exports__